import List from "@material-ui/core/List";
import React from "react";
import User from "./User";
import {ClickAwayListener, Popper} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import classes from "./Selector.module.css";
import {translation} from "../../../I18n/i18n";

let Element = props => {
    return <Popper
        id={ "_proposals" }
        open={ props.open }
        anchorEl={ props.anchorEl }
        placement={ "bottom-start" }
        className={ classes.menu }
        style={ {
            width: document.getElementById ("_selectorInput")
                && document.getElementById ("_selectorInput").clientWidth
        } }
    >
        <ClickAwayListener onClickAway={ props.onClose }>
            <List>
                { !props.proposals.length &&
                <ListItem disabled> { translation (props.lang, "No options") } ... </ListItem> }
                { props.proposals.map ((user, i) => (
                    <User { ...user }
                          key={ i }
                          selected={ props.selection === i }
                          selection={ props.selection }
                          onSelect={ props.onSelect }
                          onClose={ props.onClose }
                          token={ props.token }
                    />)) }
            </List>
        </ClickAwayListener>
    </Popper>
}

export default Element;